import { useContext } from "react";
import {
  CurrentUserContext,
  type CurrentUser,
  type CurrentUserContextValue,
} from "@/hooks/currentUserContext";

/**
 * Returns the current authenticated user (or null while unresolved / signed out).
 * Provider IDs come from GET /api/v1/me via CurrentUserProvider.
 */
export function useCurrentUser(): CurrentUser | null {
  return useContext(CurrentUserContext).user;
}

/**
 * Returns a function that re-fetches /me and refreshes providerIds in context.
 * Used after provider create / user link-unlink so dropdowns update without reload.
 */
export function useRefreshCurrentUser(): CurrentUserContextValue["refreshCurrentUser"] {
  return useContext(CurrentUserContext).refreshCurrentUser;
}
